<template>
<div id="sms">
    <div class="wrapper stepUp">
        <div class="d23"></div>
        <div class= "formaWrap">
    <p>Вам отправлено смс с кодом подтверждения<br> Для завершения оформления, введите код подтверждения</p>
    <input type="text" v-model="confCode"  placeholder="Код подтверждения" v-on:blur="blurconfCode">
    <p v-if="errconfCode.length > 0" class=errconfCode>{{errconfCode}}</p>
    <div>
    <button type="button" class="btn" v-on:click="checkConfCode">Далее</button>
    </div>
</div>
</div>
</div>
</template>

<script>
 import {mapState} from 'vuex'
export default {
  name: 'sms',
   data(){
return{
    control: true,
    errconfCode:'',
}
},
methods:{
    checkConfCode(){
        this.blurconfCode();
        if (this.errconfCode.length == 0) {
            this.$myApi.SendRequest({
                action: 'SendAlfaECPConfCode',
                ConfirmationGUID : this.valueVuex.AlfaCard_FormSaved.ConfirmationGUID,
                ConfirmationCode  : this.confCode
            }).then((res)=>{
                if (res.CheckResult) {

                    this.$myApi.singleRequest({
                        action:'stepSave',
                        step:'confCode',
                        result:res,
                        stepCode:1,
                        session:this.session
                    }).then((res)=>{res['asd']='asd';}).catch((res)=>{res['asd']='asd';});

                    this.$store.commit('incStepForm');
                } else {
                    this.$myApi.singleRequest({
                        action:'stepSave',
                        step:'confCode',
                        result:res,
                        stepCode:-1,
                        session:this.session
                    }).then((res)=>{res['asd']='asd';}).catch((res)=>{res['asd']='asd';});
                    this.errconfCode = 'не корректный код подтверждения ';
                }
            })
            .catch((res)=>{
                this.$myApi.singleRequest({
                    action:'stepSave',
                    step:'confCode',
                    result:res,
                    stepCode:-1,
                    session:this.session
                }).then((res)=>{res['asd']='asd';}).catch((res)=>{res['asd']='asd';});
                let err = this.$myApi.parseError(res,'SendAlfaECPConfCode');
                alert(err.ExecutionErrorMessage);
            });
              try {
            // eslint-disable-next-line
            ym(82222150, 'reachGoal', 'smsverif')
          }
          catch(e){
            console.log(e)
          }
        }
    },
    blurconfCode(){
       if (this.confCode.length == 0){
            this.errconfCode ='обязательное поле';
        } else {
           this.errconfCode ='';
        }
    },
},
computed:{
    ...mapState({
      valueVuex: state => state.alfaForm.alfaForm,
        session:state=>state.alfaForm.session,
    }),
    confCode:{
      get(){
        return this.valueVuex['confCode'];
      },
      set(value){
        this.$store.commit('setStateAlfaRoot',{
          formKey:'confCode',
          value:value
        })
      }
    },
}

}
</script>

<style scoped>
p{padding-top: 7vw; font-size: 5vw;}
#sms{ height: 140vw;}
input{margin-top: 30vw; margin-bottom: 30vwpx;}
/deep/.errconfCode{position: absolute;left: auto; width: 100%;right: auto;top: 78vw;color: red;font-size: 3.5vw;padding-top: 0px;}
button{position: absolute;bottom: 7vw;left: 23vw;}

@media screen and (min-width: 1140px) {
p{padding-top: 100px;font-size: 24px;}
#sms{ height: 674px;}

input{margin-top: 86px; margin-bottom: 86px;}
/deep/.errconfCode{top: 315px;font-size: 17px; padding-top:0px;}
button{bottom: 47px;left: 390px;}
}
</style>
